<ng-container [formGroup]="newEditForm">
    <td class="short" [ngClass]="{'show-error':showError}">
      <app-filterable-list [itemsList]="paises" [selectedItem]="newEditForm.get('pais')" [disabled]="disabledPaises" [placeHolder]="false">
      </app-filterable-list>
    </td>
    <td class="short" [ngClass]="{'show-error':showError}">
      <app-filterable-list [itemsList]="denominaciones" [selectedItem]="newEditForm.get('denominacion')" [disabled]="disabledDenominaciones" [placeHolder]="false">
      </app-filterable-list>
    </td>
    <td class="short">
      <input [id]="etiquetaDigitalId" type="checkbox" formControlName="etiquetaDigital">
      <label [for]="etiquetaDigitalId" style="margin-bottom: unset;"></label>
    </td>
    <td class="multi-actions">
        <ng-container *ngIf="creating || editing">
          <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
          <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!creating && !editing">
          <i class="fas fa-pencil-alt" title="{{'titles.editar' | translate}}" (click)="edit()"></i>
          <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" (click)="askDelete()"></i>
        </ng-container>
    </td>
</ng-container>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{'global.eliminar.descripcion' | translate}}</h4>
      </header>
      <content>
        <p>{{'global.eliminar.confirmacion' | translate}}</p>
      </content>
      <footer>
        <button class="secondary" (click)="closeModal()">{{'global.cancelar' | translate}}</button>
        <button (click)="delete()">{{'global.confirmar' | translate}}</button>
      </footer>
    </div>
</div>

<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>